import React, { useEffect, useState } from 'react';
import {  useLocation, useNavigate, useParams } from 'react-router-dom';
import networklogo from '../../images/business/networklogo.png';
import referUsIcon from '../../images/icon/referusicon.svg';
import { useDispatch } from 'react-redux';
import { businessDetailsAction } from '../../actions/business';
import { Divider, QRCode, Spin } from 'antd';
import { useSelector } from 'react-redux';
import rightImg1 from '../../images/business/logobg.png';
import { extractVideoId, formatAndCapitalizeString } from '@utils/common/common';
import VideoPlayer from '@utils/common/VideoPlayer';
// @ts-ignore
import { markettingWebUrl } from '../../environment/environment';
import '../Businesspage/index.css'
import MapComponent from '@components/map/GoogleMap';
import { Helmet } from 'react-helmet-async';


export const MarketingLandingPage = () => {
    const { businessCode, businessName, referCode } = useParams();
    const host = window.location.origin;
    const isLoading = useSelector((state: any) => state?.General?.loading);
    const [data, setData] = useState<any>(undefined);
    const [services, setServices] = useState<any>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const query = new URLSearchParams(useLocation().search);
    const referrerCode = query.get('referrerCode');
    const businessReferrer = query.get('businessReferrer');
    let registerReferrerUrl = '';
    let isReferringBusiness = businessReferrer === 'true' ? true : false;

    useEffect(() => {
        console.log('Business Code', businessCode);
        console.log('referrerCode', referrerCode);
        const payload = { businessCode };
        dispatch(
            businessDetailsAction(payload, (resp: any) => {
                console.warn('resp :::::::::::::', resp);
                if (resp?.status === 200) {
                    setData(resp?.data);
                    // setRewards(resp?.data?.rewards);
                    setServices(
                        resp?.data?.BusinessDetails?.services
                            ? resp?.data?.BusinessDetails?.services.split(',')
                            : []
                    );
                }
            })
        );
    }, [businessCode]);

    if (referrerCode) {
        registerReferrerUrl = `${host}/business-details/send-referral/${businessName}/${businessCode}/sender/${referCode}?referrerCode=${referrerCode.toUpperCase()}`;
    } else {
        registerReferrerUrl = `${host}/business-details/send-referral/${businessName}/${businessCode}/sender/${referCode}`;
    }

    const handleJoinUs = () => {
        if(!businessReferrer) {
            navigate(
                `/contact-us`, { state: data }
            );
        } else {
            navigate(
                `/business-details/send-referral/${businessName}/${businessCode}/sender/${referCode}`, { state: data }
            );
        }
    };

    const handleReferUs = (event: any) => {
        event.preventDefault();
        window.open(`${markettingWebUrl}/register`, '_blank', 'noopener,noreferrer');
    }
    const pageTitle = `${data?.companyName ? data.companyName : 'Referrer'} Marketing Page`;
    let descriptions = `Get more referrals from this page for ${data?.companyName ? data.companyName : 'your business'}`

    return (
        <>
        {isLoading ? <Spin fullscreen></Spin> : 
            <div className="marketingSite">
                    <Helmet>
                        <title>{pageTitle}</title>
                        <meta name="description" content={descriptions} />
                        <meta property="og:title" content={pageTitle} />
                        <meta property="og:description" content={descriptions} />
                        <meta property="og:type" content="website" />
                        {/* <link rel="icon" href="../../images/logo/favicon.ico" /> */}
                    </Helmet>
                <div
                    className="coverpage d-flex"
                >
                    <div className="left-img-col" style={{ backgroundColor: data?.BusinessDetails?.backgroundColor || 'rgb(255, 244, 237)' }}>
                        <img src={data?.BusinessDetails?.logoUrl || rightImg1} alt="logo" />
                    </div>
                    <div className="brand-icon">
                        <p>

                            <img src={referUsIcon} alt="referUsIcon" />
                            Powered by ReferUs Network - <a style={{ color: "#F47523" }} href="https://www.referusnetwork.com" target='_blank'>www.ReferUsNetwork.com</a>
                        </p>
                    </div>

                    <div className="container">
                        <div className="lowerprofile">
                            <div className="leftContent">
                                <div className="textmarketing">
                                    <div className="head">{data?.BusinessDetails?.businessName}</div>
                                    <div className="subHead">
                                        {formatAndCapitalizeString(data?.businessCategory)}
                                    </div>
                                </div>
                            </div>
                            <div className="rightContent">

                                <div className="socialmedIcons">
                                    {data?.socialMediaUrl?.facebook && (
                                        <a
                                            className="socialIcons"
                                            href={data?.socialMediaUrl?.facebook?.startsWith('http')
                                                ? data.socialMediaUrl.facebook
                                                : `https://${data?.socialMediaUrl?.facebook}`
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="12"
                                                height="23"
                                                viewBox="0 0 12 23"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.93753 22.2602V12.3217H11.2721L11.7724 8.44735H7.93753V5.97415C7.93753 4.85278 8.24765 4.08859 9.8575 4.08859L11.9074 4.08774V0.62239C11.5529 0.576322 10.336 0.470703 8.91971 0.470703C5.96222 0.470703 3.93748 2.27592 3.93748 5.59043V8.44735H0.592773V12.3217H3.93748V22.2602H7.93753Z"
                                                    fill="#3F6AF6"
                                                />
                                            </svg>
                                        </a>
                                    )}
                                    {data?.socialMediaUrl?.instagram && (
                                        <a
                                            className="socialIcons"
                                            href={data?.socialMediaUrl?.instagram?.startsWith('http')
                                                ? data.socialMediaUrl.instagram
                                                : `https://${data?.socialMediaUrl?.instagram}`
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="23"
                                                height="23"
                                                viewBox="0 0 23 23"
                                                fill="none"
                                            >
                                                <path
                                                    d="M22.5824 6.87491C22.5313 5.71716 22.3441 4.92121 22.0759 4.23151C21.7992 3.49941 21.3736 2.84396 20.8159 2.29908C20.271 1.74573 19.6113 1.31574 18.8876 1.04339C18.1939 0.775191 17.4022 0.587968 16.2444 0.536922C15.078 0.481553 14.7077 0.46875 11.7494 0.46875C8.79106 0.46875 8.42077 0.481553 7.25869 0.532599C6.10094 0.583645 5.30499 0.771034 4.61546 1.03907C3.88319 1.31574 3.22774 1.7414 2.68287 2.29908C2.12951 2.84396 1.6997 3.50373 1.42718 4.22735C1.15898 4.92121 0.971757 5.71283 0.920711 6.87059C0.865342 8.037 0.852539 8.40728 0.852539 11.3656C0.852539 14.3239 0.865342 14.6942 0.916388 15.8563C0.967433 17.0141 1.15482 17.81 1.42302 18.4997C1.6997 19.2318 2.12951 19.8873 2.68287 20.4321C3.22774 20.9855 3.88751 21.4155 4.61113 21.6878C5.30499 21.956 6.09661 22.1433 7.25454 22.1943C8.41645 22.2455 8.78691 22.2582 11.7452 22.2582C14.7036 22.2582 15.0738 22.2455 16.2359 22.1943C17.3937 22.1433 18.1896 21.956 18.8792 21.6878C20.3435 21.1217 21.5013 19.9639 22.0674 18.4997C22.3355 17.8059 22.5229 17.0141 22.5739 15.8563C22.6249 14.6942 22.6378 14.3239 22.6378 11.3656C22.6378 8.40728 22.6334 8.037 22.5824 6.87491ZM20.6202 15.7712C20.5733 16.8353 20.3946 17.41 20.2456 17.7931C19.8795 18.7423 19.1261 19.4957 18.1768 19.8618C17.7937 20.0108 17.2149 20.1896 16.1549 20.2363C15.0057 20.2875 14.661 20.3001 11.7537 20.3001C8.84643 20.3001 8.49742 20.2875 7.3523 20.2363C6.28816 20.1896 5.71352 20.0108 5.33043 19.8618C4.85805 19.6872 4.42807 19.4106 4.07906 19.0488C3.71725 18.6954 3.44057 18.2698 3.26599 17.7974C3.11701 17.4143 2.93826 16.8353 2.89154 15.7755C2.84033 14.6262 2.82769 14.2814 2.82769 11.3741C2.82769 8.46681 2.84033 8.1178 2.89154 6.97285C2.93826 5.9087 3.11701 5.33406 3.26599 4.95097C3.44057 4.47842 3.71725 4.04861 4.08338 3.69943C4.43655 3.33762 4.8622 3.06095 5.33475 2.88652C5.71784 2.73754 6.29681 2.5588 7.35663 2.51191C8.5059 2.46087 8.85075 2.44806 11.7579 2.44806C14.6695 2.44806 15.0142 2.46087 16.1593 2.51191C17.2234 2.5588 17.7981 2.73754 18.1811 2.88652C18.6535 3.06095 19.0835 3.33762 19.4325 3.69943C19.7943 4.05276 20.071 4.47842 20.2456 4.95097C20.3946 5.33406 20.5733 5.91286 20.6202 6.97285C20.6712 8.12213 20.684 8.46681 20.684 11.3741C20.684 14.2814 20.6712 14.6219 20.6202 15.7712Z"
                                                    fill="#3F6AF6"
                                                />
                                                <path
                                                    d="M11.7498 5.76758C8.65957 5.76758 6.15234 8.27464 6.15234 11.365C6.15234 14.4553 8.65957 16.9624 11.7498 16.9624C14.8401 16.9624 17.3472 14.4553 17.3472 11.365C17.3472 8.27464 14.8401 5.76758 11.7498 5.76758ZM11.7498 14.9959C9.745 14.9959 8.11885 13.3699 8.11885 11.365C8.11885 9.36007 9.745 7.73409 11.7498 7.73409C13.7547 7.73409 15.3807 9.36007 15.3807 11.365C15.3807 13.3699 13.7547 14.9959 11.7498 14.9959V14.9959Z"
                                                    fill="#3F6AF6"
                                                />
                                                <path
                                                    d="M18.8754 5.54698C18.8754 6.2686 18.2903 6.85372 17.5685 6.85372C16.8468 6.85372 16.2617 6.2686 16.2617 5.54698C16.2617 4.82518 16.8468 4.24023 17.5685 4.24023C18.2903 4.24023 18.8754 4.82518 18.8754 5.54698V5.54698Z"
                                                    fill="#3F6AF6"
                                                />
                                            </svg>
                                        </a>
                                    )}
                                    {data?.socialMediaUrl?.linkedIn && (
                                        <a
                                            className="socialIcons"
                                            href={data?.socialMediaUrl?.linkedIn?.startsWith('http')
                                                ? data.socialMediaUrl.linkedIn
                                                : `https://${data?.socialMediaUrl?.linkedIn}`
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="23"
                                                height="23"
                                                viewBox="0 0 23 23"
                                                fill="none"
                                            >
                                                <g clip-path="url(#clip0_423_15076)">
                                                    <path
                                                        d="M22.1199 22.2607V22.2598H22.1254V14.2685C22.1254 10.3591 21.2837 7.34766 16.7134 7.34766C14.5163 7.34766 13.0418 8.55334 12.4399 9.69638H12.3764V7.71263H8.04297V22.2598H12.5552V15.0566C12.5552 13.16 12.9147 11.3261 15.2635 11.3261C17.5777 11.3261 17.6122 13.4905 17.6122 15.1782V22.2607H22.1199Z"
                                                        fill="#3F6AF6"
                                                    />
                                                    <path
                                                        d="M0.695312 7.71289H5.213V22.2601H0.695312V7.71289Z"
                                                        fill="#3F6AF6"
                                                    />
                                                    <path
                                                        d="M2.95151 0.470703C1.50705 0.470703 0.334961 1.6428 0.334961 3.08726C0.334961 4.53172 1.50705 5.72832 2.95151 5.72832C4.39597 5.72832 5.56807 4.53172 5.56807 3.08726C5.56716 1.6428 4.39507 0.470703 2.95151 0.470703V0.470703Z"
                                                        fill="#3F6AF6"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_423_15076">
                                                        <rect
                                                            width="21.7895"
                                                            height="21.7895"
                                                            fill="white"
                                                            transform="translate(0.334961 0.470703)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div className="contentPage">
                    <div className="container">
                        <div className="backcard">
                            <div className="row">
                                <div className="col-lg-6 col-sm-12">
                                    <div className="blockdesign">
                                        <div className="blockheading">
                                            Get To Know About Us
                                        </div>
                                        <div className="blockContent">
                                            {data?.BusinessDetails?.description}
                                            {/* All Opportunities is Indonesia's largest opportunity portal & mentoring platform. We help people easily find opportunities to top Indonesian companies for internship and full-time roles.
                                            As you might have already heard about us, we are revolutionizing how Indonesian engage with employers. Many Indonesian students are talented, ambitious, but never found a better opportunity for themselves. Our team is driven by the vision to democratize information and knowledge, thus opportunities. We think what we build will allow Indonesian students to have a chance to self develop and have a better future */}
                                        </div>
                                    </div>
                                    {data?.BusinessDetails?.selectedKey ===
                                        'address' && (
                                            <div className="blockdesign">
                                                <div className="blockheading">
                                                    Our Address
                                                </div>
                                                <div className="blockContent">
                                                    {data?.BusinessDetails?.address}
                                                </div>
                                            </div>
                                        )}
                                    {data?.BusinessDetails?.contactNumber && (
                                        <div className="blockdesign">
                                            <div className="blockheading">
                                                Our Contact
                                            </div>
                                            <div className="blockContent">
                                                {data?.contactNumber}
                                            </div>
                                        </div>
                                    )}
                                    <div className="blockdesign">
                                        <div className="blockheading">Services</div>
                                        <div className="blockContent">
                                            <ul>
                                                {services.map(
                                                    (service: any, index: any) => (
                                                        <li key={index}>
                                                            {service}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="blockdesign" style={{ marginTop: '50px' }}>
                                        <div className="blockheading">
                                            Scan the QR Code below to become a referrer for {data?.BusinessDetails?.businessName} {' '}
                                            and receive "rewards" </div>
                                        <div className="blockContent">
                                            <div className='d-flex'>
                                                <div className='join-referrer'>
                                                    <div>
                                                        <p>Use ReferUs Network for your business. Join Now</p>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={handleJoinUs}
                                                        >
                                                            {!isReferringBusiness ? "Contact Us" : "Refer Us"}
                                                        </button>
                                                        <p>Select this button to signup as referrer for <i><u>{data?.BusinessDetails?.businessName}{' '}</u></i></p>
                                                    </div>
                                                </div>

                                                <div className='devider'>
                                                    <Divider type="vertical" style={{ borderLeft: '2px dashed #F47523', height: '45%', marginTop: '0px' }} />
                                                    <span className='divider-text'>Or</span>
                                                    <Divider type="vertical" style={{ borderLeft: '2px dashed #F47523', height: '45%', marginTop: '0px' }} />
                                                </div>
                                                <div className="qrBlock">
                                                    <QRCode
                                                        size={150}
                                                        value={
                                                            registerReferrerUrl || '-'
                                                        }
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-12">
                                    <div className="decoLinks">
                                        {data?.BusinessDetails?.selectedKey ===
                                            'address' && (
                                                <div className="mapsMarketing">
                                                    <MapComponent lat={data?.BusinessDetails?.lat} lng={data?.BusinessDetails?.long} />
                                                </div>
                                            )}

                                        {data?.BusinessDetails?.selectedKey ===
                                            'graphic' && (
                                                <div className="mapsMarketing graphic">
                                                    <img
                                                        src={
                                                            data?.BusinessDetails
                                                                ?.bannerUrl
                                                        }
                                                        alt="graphic"
                                                    />
                                                </div>
                                            )}

                                        {data?.BusinessDetails?.selectedKey ===
                                            'link' && (
                                                <div className="mapsMarketing graphic">
                                                    <VideoPlayer videoId={extractVideoId(data?.BusinessDetails?.link)} />
                                                </div>
                                            )}

                                        <div className="addverstiseSection">
                                            <img src={networklogo} alt="ReferUs" />
                                            <h4>
                                                Manage your Word-of-Mouth Referrals
                                            </h4>
                                            <p>
                                                Get your happy clients referring you
                                                with ReferUs. When it comes to
                                                marketing your business there's no
                                                one better than a happy customer{' '}
                                            </p>
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleReferUs}
                                            >
                                                Join ReferUs Now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footerbusiness">
                    <div className="text-center">
                        <div className="footerbusinesstext">
                            © {new Date().getFullYear()} ReferUs , All rights
                            reserved
                        </div>
                    </div>
                </div>
            </div>
        }
        </>
    );
};
